import http from '../services/http';

const signature = {
  uploadSignature(stream, filename) {
    return http.request({
      method: 'post',
      url: '/uploads/signatures',
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      params: {
        filename,
      },
      data: stream,
    });
  },
  retrieveSignature() {
    // return http.request({
    //   method: 'get',
    //   url: `/uploads/signatures/${fileId}`,
    //   responseType: 'blob',
    // });
    return http.request({
      method: 'get',
      url: '/users/me/signature-profile',
    });
  },
  createSignature(data) {
    return http.request({
      method: 'post',
      url: '/users/me/signature-profile',
      data,
    });
  },
  updateSignature(data) {
    return http.request({
      method: 'patch',
      url: '/users/me/signature-profile',
      data,
    });
  },
};

export default signature;
